
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import moment from "moment";
import * as Config from "../constants/Config";
import OTPInput from "otp-input-react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { SettingsSystemDaydreamSharp } from "@mui/icons-material";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, country, appname } = window.app;

const SignIn = () => {
  let { id } = useParams();
  const [pwd, setPwd] = useState('');
  const [emailId, setEmailId] = useState("")
  const [email, setEmail] = useState("");
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [config, setConfig] = useState({});
  const navigate = useNavigate();
  const [activeLoad, setActiveLoad] = useState("");

  const [image, setImg] = useState('');
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [BtnLoader, setBtnLoader] = useState('');
  const [otpclass, setOtpClass] = useState(false);
  const [otp, setShowOtp] = useState(false)

  const [signinOtp, setSigninOtp] = useState("");
  const [visibility, setVisibility] = useState({ newpwd:false,cnfrmpwd:false,showpassword:false });
  const [componentType,setComponentType]=useState("");
  const [resendActive, setResendActive] = useState(false);
  const { userData, setUserData, activeMenuObj,uploadLogo, setUploadLogo, setActiveMenuObj, GetClientDataContext, activeMenuId, setActiveMenuId } = useContext(contentContext)

 
  // const websitedefaults = async () => {
  //     try {
  //         console.log(tmdbApi);
  //         const response = await tmdbApi.websitedefaults();

  //         console.log(response);
  //     } catch {
  //         console.log("error");
  //     }
  // };
  useEffect(() => {
    if (id) {
      getuser();
  }
   }, []);
  useEffect(() => {

    if (window.site === undefined) {
        setTimeout(() => {
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
        setImg(window.site.common.imageCloudfront)
    }


}, [window.site]);


  //  useEffect(() => {
  //      if ((localStorage.getItem("clientid"))) {
  //          GetUserDataSignIn();
  //      }
  //  }, []);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }

  }, []);
  const getuser = (e) => {
    // GetTimeActivity()   
    const token = localStorage.getItem("token")
    axios({
        method: 'GET',
        url: lambda + '/clientUserInfo?appname=' + appname+"&clientid="+id 
    })
        .then(function (response) {
            //  console.log("response", response?.data?.result?.[0]);
            if (response?.data?.result==="Invalid token or Expired") {
              setShowSessionPopup(true)
            }
            else {
                if (response?.data?.result.length > 0) {
                  setEmail(response?.data?.result?.[0]?.emailId);
                    
                } else {
                    // setInvalidContent(true)
                }
            }
            // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
        });
}
  const GetClientData = async () => {
    try {
      const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
      // console.log('loginType', loginType);
      let response;
      if (loginType === 'admin') {
        response = await tmdbApi.getAdminData({});
      } else {
        response = await tmdbApi.getClientUserData({});
      }

      if (response?.statusCode === 200) {
        setUserData(response?.result?.[0]);
        setUploadLogo(response?.result?.[0]?.logo)
        if(response?.result?.[0]?.usertype==="STORE MANAGER"){
          navigate("/storemanagement")
        }else{
          navigate("/dashboard")
        }
        // console.log("responseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",response?.result?.[0])
        localStorage.setItem("ClientName", response?.result?.[0]?.name);
        localStorage.setItem("ClientType", response?.result?.[0]?.type);
        let userArr = response?.result?.[0]?.permissions;

        const obj = userArr.reduce((acc, item) => {
          if (item.submenus) acc[item.menu] = false;
          return acc;
        }, {});
      }
    } catch {
      console.log("error");
    }
  };
  const handleKeypress = (e) => {
    //it triggers by pressing the enter key

    if ((e.key === "Enter")) {
      setTimeout(function () {
        handleSignIn();
        console.log("called");
      }, 1000);
    }
  };

  const handleSignIn = (e) => {
   
    console.log("called1");
    if (email === "" && pwd === "") {
      setError("Please enter Email and Password");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (email === "") {
      setError("Please enter Email");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (pwd === "") {
      setError("Please enter Password");
      setTimeout(function () { setError("") }, 3000);
    }
    if (email && pwd) {
      setBtnLoader("loginpwd")
      SigninPwd();
    }
  }

  //  const loginPwd = async () => {
  //      try {

  //          const response = await tmdbApi.signin({
  //              "emailid": email,
  //              "password": pwd,
  //              "useragent": JSON.parse(localStorage.getItem("loc"))
  //          });
  //          console.log(response);
  //          if (response?.statusCode===200 && response?.result === "Invalid email or password") {
  //              setError(response?.result);
  //              setTimeout(function () { setError("") }, 3000);
  //              setBtnLoader("")
  //          } else if (response?.result === "Session Already Exists") {
  //              // signoutsession()
  //              setShowSessionPopup(true)
  //              setBtnLoader("")
  //          }else if(response?.statusCode===200 && localStorage.getItem("check") ){
  //              localStorage.setItem("token", response?.result.token.token);
  //              localStorage.setItem("userId", response?.result.userid);
  //              GetUserDataSignIn();
  //              localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
  //              window.location.replace("/viewcontent/" + localStorage.getItem("check"));
  //              localStorage.removeItem("check");

  //          } else {
  //              localStorage.setItem("token", response?.result.token.token);
  //              localStorage.setItem("userId", response?.result.userid);
  //              GetUserDataSignIn();
  //              localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
  //              // navigate("/usermanagement");
  //          }


  //      } catch {
  //          console.log("error");
  //          setBtnLoader("")
  //          setError("Invalid email or password");
  //          setTimeout(function () { setError("") }, 3000);
  //      }
  //  };
  // console.log('userDatauserDatauserData', userData)
  const GetUserDataSignIn = async () => {
    try {

      const response = await tmdbApi.getClientData({});

      if (response?.statusCode === 200) {

        setUserData(response?.result?.[0]);
        localStorage.setItem("ClientName", response?.result?.[0]?.name)
        localStorage.setItem("ClientType", response?.result?.[0]?.type)
        let userArr = response?.result?.[0]?.permissions
        const EMAILID = response?.result?.[0]?.emailid
        console.log('user email', EMAILID)
        window.clarity("set", "orasi_user_email", EMAILID)
        // Clarity.addTag('Orasi User Email', EMAILID);
        const obj = userArr.reduce((acc, item) => {
          if (item.submenus) acc[item.menu] = false;
          return acc;
        }, {});
        // console.log('objjjjjjjj--->',obj)

        if (!(localStorage.getItem("check"))) {
          let k = response?.result?.[0]

          let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
          let filterdList = permissionList.filter((item) => item.display===true)
          const data = filterdList?.filter((value) => value?.menu === "Dashboard")
          let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

          navigate("/" + id);
          navigate("/users");


          setActiveMenuId(data && data[0] && data[0].menuid)
          console.log("activeMenuid------->", data)
        }

        // setActiveMenuObj(obj)
        setBtnLoader("")
        // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
      }
    } catch {
      setBtnLoader("")
      console.log("error");
    }
  };
  const AddNotify = () => toast.success('mail sent successfully', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true, 
    progress: undefined,
    theme: "light",
},)

  const clentForgotPassword = async () => {
    try {
      setActiveLoad("forgotpwd")
      const response = await tmdbApi.ClientForgotPassword({
        "emailId": email
      });
      console.log(response);
      if (response.statusCode===200) {
        // setSuccess(true);
        if (response.result === "PENDING VERIFICATION") {
            setError("Please Complete SignUp Process");
            setTimeout(function () { navigate("/signup") }, 3000);

        }  else if (response.result === "PENDING REGISTRATION") {
            setError("Please Complete SignUp Process");
            setTimeout(function () { navigate("/signup") }, 3000);

        } else if (response.result === "Client not found") {
            setError("User not Found. Please SignUp ");
            setTimeout(function () { setError("")}, 3000);
        } else if (response.result === "user not found") {
            setError("User not Found. Please SignUp ");
            setTimeout(function () { setError("")}, 3000);
        } else if (response.result === "PENDING APPROVAL") {
            // setError("Please Wait For Admin Approval");
            navigate("/thankyou")
            setTimeout(function () {setError("") }, 3000);
        }else if (response.result === "Email does not exists") {
          setError("Email does not exists");
          setTimeout(function () {setError("") }, 3000);
      }
       
        else if(response?.result==='mail sent successfully'){
          console.log("successssssssssssssss")
            AddNotify();   
        }
        setActiveLoad("")
    } else {
        setActiveLoad("")
        setError("invalid Email Id");
        setTimeout(function () { setError("") }, 3000);
    }
     
    } catch {
      console.log("error");
      setBtnLoader("")
      setError("Please enter email id");
      setTimeout(function () { setError("") }, 3000);
    }
  };
console.log(email,'emailllll')
const emailValidation = (e)=> {
  let flag = true;
  const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
  if (regEx.test(email)) {
      setError("");

  } else if (!regEx.test(email) && email !== "") {
      setError("Email is Not Valid");
      setTimeout(function () { setError("")}, 3000);
      flag = false;
  }
  if (email === "") {
      setError("Please Enter Email");
      setTimeout(function () { setError("")}, 3000);
      flag = false;
  }
  return flag

}


  //  const signin = async () => {
  //     try {
  //         const response = await tmdbApi.signin({
  //             "emailid": email,
  //             "logintype": "otp"
  //         });
  //         if(response?.result==="Client not found"){
  //             setError("Client not Found. Please SignUp ");
  //         } else if(response.result === "PENDING VERIFICATION"){
  //             setError("Please Complete SignUp Process");
  //         }else{
  //             console.log(response);
  //         }
  //         // console.log()

  //         // if (response.statusCode === 200) {
  //     //     if (response.result === "PENDING VERIFICATION") {
  //     //         setError("Please Complete SignUp Process");
  //     //         setTimeout(function () { navigate("/signup") }, 3000);

  //     //     } else if (response.result === "PENDING TERMS") {
  //     //         setError("Please Check And Accept Terms ");
  //     //         setTimeout(function () { navigate("./terms/"+email) }, 3000);

  //     //     } else if (response.result === "PENDING REGISTRATION") {
  //     //         setError("Please Complete SignUp Process");
  //     //         setTimeout(function () { navigate("/signup") }, 3000);

  //     //     } else if (response.result === "user not found") {
  //     //         setError("User not Found. Please SignUp ");
  //     //         // setTimeout(function () { setError("")}, 3000);
  //     //     } else if (response.result === "PENDING APPROVAL") {
  //     //         setError("Please Wait For Admin Approval");
  //     //         setTimeout(function () { navigate("/message") }, 3000);
  //     //     }
  //     //     else if (response.result === "REJECT") {
  //     //         localStorage.setItem("rejected", response.result);
  //     //         handleShowPopup("Your account has not been approved.")

  //     //     }  else if (response.result === "Invalid password") {
  //     //         setError("Invalid password");
  //     //     } else if (response.result === "Invalid email") {
  //     //         setError("Invalid email");
  //     //     }else if (response.result === "Client not found") {
  //     //         setError("User not Found. Please SignUp ");
  //     //     }else if (response.result === "INACTIVE") {
  //     //         localStorage.setItem("inactive", response.result);
  //     //         handleShowPopup("Your account has been deactivated.")
  //     //         // setTimeout(function () { navigate("/signup") }, 3000);
  //     //     }else if (response.result === "Session Already Exists") {
  //     //         // signoutsession()
  //     //        setShowSessionPopup(true)
  //     //     }else if (response.result === "ACTIVE" || response.result === "Email Sent Successfully") {
  //     //         localStorage.setItem("loginuser", email);
  //     //         localStorage.setItem("login", "setlogin");
  //     //         let currentDate = new Date().toJSON();
  //     //         localStorage.setItem("currentSessionClientTime", currentDate);
  //     //         setWelcomeMsg(true)

  //     //         navigate("/loginotp");
  //     //     }
  //     //     else {
  //     //         setError("Invalid Details");

  //     //     }
  //     // setActiveLoad("")
  //     } catch {
  //         // setActiveLoad("")
  //         // navigate("/loginotp");
  //         console.log("error");
  //     }
  // };

  const signOtp = async () => {

    try {
      //   setActiveLoad("loginOtp")
      const response = await tmdbApi.signOtp({
        "emailid": email,
        "logintype": "otp",
        "otp": Number(signinOtp),
        // "useragent" : locData?.headers !== undefined ? locData?.headers : {}
      });
      if (response.result.res === "password not set") {
        localStorage.setItem("clientid", response.result.clientid);
        navigate("/generatepwd/?id=" + response.result.clientid);
      } else if (response?.result === "Invalid otp entered") {
        setOtpClass(true); // Handle invalid OTP
      } else if (response.result.token) {
        console.log("came");
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        
        
        GetClientData()
      }
      setActiveLoad("");
      console.log(response);

      //   if (response.result.res === "password not set") {
      //     localStorage.setItem("clientid", response.result.clientid);
      //     navigate("/generatepassword/?id="+response.result.clientid);
      //   }else if(localStorage.getItem("check") && response.statusCode === 200){
      //     console.log("came");
      //     localStorage.setItem("token", response.result.token);
      //     localStorage.setItem("clientid", response.result.clientid);
      //     localStorage.setItem("login", "setlogin");
      //     let currentDate = new Date().toJSON();
      //     localStorage.setItem("currentSessionClientTime", currentDate);
      //     GetClientDataFunction();
      //     navigate("/moreinfo/" + localStorage.getItem("check"));
      // } else if (response.result.token) {
      //     console.log("came");
      //     localStorage.setItem("token", response.result.token);
      //     localStorage.setItem("clientid", response.result.clientid);
      //     let currentDate = new Date().toJSON();
      //     localStorage.setItem("currentSessionClientTime", currentDate);
      //     navigate("/content");
      //   } else {
      //     // setError(response.result);
      //     // setTimeout(function () { setError("") }, 3000);
      //     // var element = document.getElementById("otp");
      //     // element.classList.add("invalid");
      //     // setTimeout(function () { 
      //     // element.classList.remove("invalid");
      //     // setOtp("")
      //     // one.current.value="";
      //     // two.current.value="";
      //     // three.current.value="";
      //     // four.current.value="";
      //     // five.current.value="";
      //     //  }, 3000);
      //     setOtpClass(true)
      //     setActiveLoad("")
      //   }
    } catch {
      //   setActiveLoad("")
      console.log("error");
      // var element = document.getElementById("otp");
      // element.classList.add("invalid");

      //   setTimeout(function () { 
      //     element.classList.remove("invalid");
      //   setOtp("")
      // }, 3000);
    }
  };



  const handleForgot = (e) => {
 
      clentForgotPassword();
    
  }

  // function onConfirm() {
  //   setSuccess(false);
  // };

  // const handleShowSessionPopup = () => {
  //   setShowSessionPopup(true)
  // }
  const onCancel = () => {
    setShowSessionPopup(false)
    setBtnLoader("")
  }
  const signoutsession = async () => {
    try {
      setBtnLoader("sessionLoad")
      const response = await tmdbApi.SignOutUser({ emailId: email });
      console.log(response);
      if (response?.result==="Success") {
        SigninPwd()
      } else {
        setError("Invalid Details");
        setBtnLoader("")
      }
    } catch {
      setBtnLoader("")
      console.log("error");
    }
  }

  // const handleMessage = (e) => {
  //   setError("");
  // }


  const SigninPwd = async () => {
    setActiveLoad("loginpwd") 
    try {

      const response = await tmdbApi.signin({
        "emailId": email,
        "logintype": "password",
        "password": pwd,

      });
      console.log(response);
      console.log(response.result);
      if (response.result === "Invalid email or password") {
        setError(response.result);
        //setTimeout(function () { setError("") }, 3000);
      } else if (response.result === "Please log in using OTP and set a password") {
        setActiveLoad("")
        setError("Please log in using OTP and set a password");
   
        setTimeout(function () { navigate("/signup") }, 3000);
        // } else if (response.result === "REJECT") {
        //     // localStorage.setItem("rejected", response.result);
        //     handleShowPopup("Your account has not been approved.")

        // } else if (response.result === "INACTIVE") {
        //     // localStorage.setItem("inactive", response.result);
        //     handleShowPopup("Your account has been deactivated.")
        //     // setTimeout(function () { navigate("/signup") }, 3000);
      }
      else if (response.result === "Session Already Exists") {
        // signoutsession()
        //    setShowSessionPopup(true)
      }
      else if (response.result === "PENDING VERIFICATION") {
         setActiveLoad("")
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/") }, 3000);

      } else if (response.result === "PENDING TERMS") {
        setActiveLoad("")
        setError("Please Check And Accept Terms ");
        // setTimeout(function () { navigate("./terms/"+email) }, 3000);

      } else if (response.result === "PENDING REGISTRATION") {
        setActiveLoad("")
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/") }, 3000);

      } else if (response.result === "user not found") {
        setActiveLoad("")
        setError("User not Found. Please SignUp ");
        setTimeout(function () { setError("") }, 3000);
      } else if (response.result === "PENDING APPROVAL") {
        setActiveLoad("")
        // setError("Please Wait For Admin Approval");
        navigate("/thankyou")
        // setTimeout(function () { setError("")}, 3000);
      } else if (response.result === "Invalid password") {
        setActiveLoad("")
        setError("Invalid password");
        setTimeout(function () {setError("") }, 3000);
      } else if (response.result === "Client not found") {
        setError("Client not Found. Please SignUp ");
        setTimeout(() => {
          setError("");  // Clears the error after 3 seconds
        }, 3000);
        setActiveLoad("")
      } else if (response.result === "Invalid email") {
        setActiveLoad("")
        setError("Invalid email");
        setTimeout(() => {
          setError("");  // Clears the error after 3 seconds
        }, 3000);
      } else if (response.result === "INACTIVE") {
        setActiveLoad("")
        setError("User inactive. Please contact the administrator");
        setTimeout(() => {
          setError("");  // Clears the error after 3 seconds
        }, 3000);
      } else if (response.result && response.result.token) {
        // console.log('elseeeeeee block of signin')
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");
        // console.log('response.result.clientid', response.result.clientid)
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        // setWelcomeMsg(true)
        // GetClientDataFunction();
        GetClientData();
        setActiveLoad("") 
       
      }
      else {
        setError("Invalid Details");
        setActiveLoad("")

      }
      // setActiveLoad("")
    } catch {
      // setActiveLoad("")
      console.log("error");
    }
  };


  const handleClick = async (data) => {
      
    if (data === "otp") {
    
      const validate = emailValidation();
    
      if (validate) {
        setActiveLoad("otplogin")
        try {
          const response = await tmdbApi.signin({
            emailId: email,
            logintype: "otp",
          });
  
          if (response?.result === "Client not found") {
            setActiveLoad("")
            setError("Client not Found. Please SignUp ");
            setTimeout(function () { setError("") }, 3000);
          } else if (response.result === "PENDING VERIFICATION") {
            setError("Please Complete SignUp Process");
            setTimeout(function () { setError("") }, 3000);
            setActiveLoad("")
          }else if (response.result === "PENDING APPROVAL") {
            // setError("Please Wait For Admin Approval");
            // setTimeout(function () { setError("") }, 3000);
             navigate("/thankyou")
            setActiveLoad("")
          } else if (response.result === "INACTIVE") {
            setActiveLoad("")
            setError("User inactive. Please contact the administrator");
            setTimeout(() => {
              setError("");  // Clears the error after 3 seconds
            }, 3000);
          }  else {
            console.log(response);
            setActiveLoad("")
            setComponentType(data);
            // setShowOtp(true); // Move inside successful response handling
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    } else{
        setComponentType(data);
      }
  
    console.log("componentTypeeeeeeeeeeeeeeeeeee", data);
  };
  const handleChange = (otp) => {
    setSigninOtp(otp)
    setOtpClass(false);
  }
  const handleResendOtp = async () => {
    setResendActive(true)
    setTimeout(function () {
      setResendActive(false)
    }, 3000)
    // setOtpClass(true)
    try {
      //   console.log(tmdbApi);
      const response = await tmdbApi.resendMailSignin({
        "emailId": email,

      });
      // setResendActive(false)
      console.log(response);
    } catch {
      setResendActive(false)

      console.log("error");
    }
  };
  const handleClose=()=>{
    if(componentType==="frgtpwd"){
      setVisibility({...visibility,showpassword:false})
      setComponentType("password")
    }else if(componentType==="recoverotp"){
  setComponentType("frgtpwd")
    }else if(componentType==="verify"){
      setComponentType("recoverotp")
      
    }else{
      setComponentType("")
      setVisibility({...visibility,newpwd:false,cnfrmpwd:false})
      navigate("/")
    }
     
  }
  const handleLogin=(type) =>{
    if(type==="otp"){
      if(signinOtp===""){
        setOtpClass(true)
      }else{
          setActiveLoad("confirmotp")
        signOtp()
      }
       
    }else{
        handleSignIn()
    }
  }

  return (
    <>
    <Modal className="access-denied" show={showSessionPopup} id="accessDeniedModal">
      <div className="modal-body enquiry-form">
        <div className="container">
          <button className="close-btn" onClick={e => onCancel()} id="closeSessionPopupBtn">
            <span className="material-icons">close</span>
          </button>
          <span className="material-icons access-denied-icon" id="sessionIcon">
            web_asset_off
          </span>
          <h3 id="sessionTitle">Multiple Sessions Found</h3>
          <p id="sessionDescription">Another session is running in another browser. Do you want to terminate that session?</p>
          <div className="popup-footer">
            <button 
              className="fill_btn yellow-gradient" 
              data-bs-toggle="modal" 
              data-bs-target="#recommendModal" 
              onClick={e => signoutsession()} 
              id="terminateSessionBtn">
              {BtnLoader === "sessionLoad" ? (
                <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />
              ) : null}
              Yes
            </button>
            <button className="fill_btn" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onCancel()} id="cancelSessionBtn">
              No
            </button>
          </div>
        </div>
      </div>
    </Modal>
  
    <div className="signin-wrapper" id="signinWrapper">
      <div className="logo_section" id="logoSection">
        <img src={`${image}${appname}/images/web/logo-dark.png`} className="logo" id="logoImage"/>
        <button className="close-btn" id="closeSigninBtn" onClick={handleClose}>
          <span className="material-icons" >close</span>
        </button>
      </div>
      <div className="signin-body" id="signinBody">
        <div className="signin-graphic" id="signinGraphic">
          <img src={`${image}${appname}/images/web/Log-in-graphic.svg`} id="signinGraphicImage"/>
          <h3 id="signinHeading">Seamless Onboarding</h3>
          <p id="signinSubheading">Successful Beginnings: Your Journey Starts Here!</p>
        </div>
  
        {componentType === "otp" ? (
          <div className="signin-section emaillogin" id="otpSection">
            <h1 className="bold-heading" id="otpHeading">Login With OTP</h1>
            <p className="mb-2" id="otpInstruction">Enter 5 Digit OTP sent to your Email</p>
            <p className="mb-2 email-show-style" id="otpEmail">{email}</p>
            <div className="otp-blocks mt-5 mb-5" id="otpBlocks">
              <div className={otpclass ? "otp-inputs block-margin signup-otp-inputs invalid errorStyle" : "otp-inputs block-margin"} id="otpInputs">
                <OTPInput value={signinOtp} onChange={handleChange} autoFocus OTPLength={5} otpType="number" id="otpInputField" />
                {signinOtp === "" ? (
                  <p id="otpError">Please enter valid otp</p>
                ) : (
                  <p id="otpErrorMessage">The OTP you have entered is incorrect. Please try again or request a new OTP</p>
                )}
              </div>
              <button className="resend-button" onClick={handleResendOtp} id="resendOtpBtn">
                Resend
              </button>
              {resendActive ? (
                <p style={{ 'font-size': '12px', 'color': 'green', 'position': 'absolute', 'left': '80px', 'bottom': '-29%' }} id="otpResentMessage">
                  OTP Resent!
                </p>
              ) : null}
            </div>
            <div className="signin-footer mt-2" id="otpFooter">
              <button className="fill-btn" onClick={() => handleLogin("otp")} id="otpLoginBtn">
                {activeLoad === "confirmotp" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="otpLoadingIcon" />
                ) : null}
                LOGIN
              </button>
              <button className="outline_btn" onClick={() => handleClick("password")} id="loginWithPasswordBtn">
                LOGIN with password
              </button>
            </div>
            <span className="errormsg" id="otpErrorMessageSpan"></span>
          </div>
        ) : componentType === "password" ? (
          <div className="signin-section emaillogin" id="passwordSection">
            <h1 className="bold-heading" id="passwordHeading">Log in to your Account</h1>
            <p id="passwordInstruction">Enter Login Credentials</p>
  
            <label className="form_label" htmlFor="usernameInput" id="usernameLabel">Email</label>
            <div className="input-group mb-2 mr-sm-2" id="usernameGroup">
              <div className="input-group-prepend">
                <div className="input-group-text"><span className="material-symbols-outlined">mail</span></div>
              </div>
              <input type="text" className="form-control" id="usernameInput" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
            </div>
  
            <label className="form_label" htmlFor="passwordInput" id="passwordLabel">Password</label>
            <div className="input-group mb-2 mr-sm-2" id="passwordGroup">
              <div className="input-group-prepend">
                <div className="input-group-text"><span className="material-symbols-outlined">lock</span></div>
              </div>
              <input
                type={visibility?.showpassword ? "text" : "password"}
                className="form-control"
                id="passwordInput"
                onChange={(e) => setPwd(e.target.value)}
                placeholder="Password"
                onKeyPress={handleKeypress}
              />
              <div className="input-group-text" onClick={() => setVisibility((prev) => ({ showpassword: !prev.showpassword }))} id="togglePasswordVisibility">
                <span className="material-symbols-outlined">{visibility.showpassword ? "visibility_off" : "visibility"}</span>
              </div>
            </div>
  
            <p className="signup-prompt mt-4 d-flex" id="rememberPassword">
              <input type="checkbox" className="me-2" id="rememberPasswordCheckbox" />
              Remember Password
              <a className="ms-auto forgot-style" onClick={() => handleForgot()} id="forgotPasswordLink">
                {activeLoad === "forgotpwd" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="forgotPasswordLoading" />
                ) : null}
                Forgot Password ?
              </a>
            </p>
  
            {error ? <span className="errormsg-floating" id="errormessage"style={{fontWeight: 'bold', color: 'red',
              }}>{error}</span> : ""}
            <div className="signin-footer mt-3" id="passwordFooter">
              <button className="fill-btn" onClick={() => handleLogin("password")} id="passwordLoginBtn">
                {activeLoad === "loginpwd" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="loginPwdLoading" />
                ) : null}
                Login
              </button>
              <button className="outline_btn" onClick={() => handleClick("otp")} id="passwordLoginWithOtpBtn">
                {activeLoad === "otplogin" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="otpLoginLoading" />
                ) : null}
                Login with OTP
              </button>
            </div>
  
            <p className="signup-prompt mt-4" id="createAccountPrompt">
              Don’t have an account?
              <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/') }} id="createAccountLink">
                Create an Account
              </a>
            </p>
          </div>
        ) : (
          <div className="signin-section emaillogin" id="defaultSection">
            <h1 className="bold-heading" id="defaultHeading">Log in to your Account</h1>
            <p id="defaultInstruction">Enter Login Credentials</p>
  
            <label className="form_label" htmlFor="usernameInput" id="defaultUsernameLabel">Email</label>
            <div className="input-group mb-2 mr-sm-2" id="defaultUsernameGroup">
              <div className="input-group-prepend">
                <div className="input-group-text"><span className="material-symbols-outlined">mail</span></div>
              </div>
              <input
                type="text"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(""); }}
                className="form-control"
                id="defaultUsernameInput"
                placeholder="Email"
              />
              {error ? (
                <span className="errormsg-floating" style={{
                  fontWeight: 'bold',
                  color: 'red',
                }} id="defaultError">
                  {error}
                </span>
              ) : ""}
            </div>
  
            <div className="signin-footer mt-4" id="defaultFooter">
              <button className="outline_btn" onClick={() => handleClick("otp")} id="defaultOtpLoginBtn">
                {activeLoad === "otplogin" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="defaultOtpLoginLoading" />
                ) : null}
                OTP LOGIN
              </button>
              <button className="fill-btn" onClick={() => handleClick("password")} id="defaultPasswordLoginBtn">
                {activeLoad === "pwdlogin" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="defaultPasswordLoginLoading" />
                ) : null}
                Password Login
              </button>
            </div>
  
            <p className="signup-prompt mt-4" id="defaultCreateAccountPrompt">
              Don’t have an account?
              <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/') }} id="defaultCreateAccountLink">
                Create an Account
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  
    <footer className="login_footer" id="loginFooter">
      <div className="container-fluid">
        <p className="footer-para" id="footerText">© 2026 SpotSaver. All rights reserved.</p>
      </div>
    </footer>
  
    <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover={false}
      theme="light"
      id="toastContainer"
    />
  </>
  
  );
};

export default SignIn;
